import { render } from "./SpecializationList.vue?vue&type=template&id=06d9d6ae&scoped=true"
import script from "./SpecializationList.vue?vue&type=script&lang=js"
export * from "./SpecializationList.vue?vue&type=script&lang=js"

import "./SpecializationList.vue?vue&type=style&index=0&id=06d9d6ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d9d6ae"]])

export default __exports__